import { createFileRoute } from '@tanstack/react-router';

import { BillingOptionCard } from '@/applications/components/billing-option-card';
import { Alert } from '@/common/components/alert';
import { Button, ButtonGroup } from '@/common/components/button';
import { Label } from '@/common/components/fieldset';
import { Heading, Subheading } from '@/common/components/heading';
import { Radio, RadioField, RadioGroup } from '@/common/components/radio';
import { Text } from '@/common/components/text';

export const Route = createFileRoute(
  '/applications/$application-id/billing-preferences'
)({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="p-8">
      <Heading>Billing Preferences</Heading>

      <Subheading>Service Location</Subheading>
      4500 Natural Bridge Rd<br/>
      Tallahassee,FL 32305

      <Alert type="info">
        A credit review has been completed and we’ve checked system information. Please review Fee information, make
        selection (if applicable), and select Next to proceed.
      </Alert>

      <Subheading>Billing Options</Subheading>
      <Text>Review the difference between Standard and Prepaid Billing before making your selections below.</Text>

      <div className="flex flex-row gap-4 mb-8">
        <BillingOptionCard
          title="Standard Billing"
          features={[
            'Billed monthly based on meter read',
            'Available for all services',
            'Deposit may be required',
            'No minimum balance required'
          ]}
        />
        <BillingOptionCard
          title="Prepaid Billing"
          features={[
            'Pay-as-you-go and maintain a daily credit balance',
            'Available for electric service only',
            'Lower deposit than Standard Billing',
            'No late fees or disconnect fees'
          ]}
        />
      </div>

      <div className="flex flex-row gap-4">
        <div className="flex flex-col w-1/2">
          <h2 className="text-xl">Choose Your Billing Preferences</h2>
          <Text>Select your billing preferences for each of the services.</Text>

          <div className="flex flex-col gap-4">
            <div className="border border-zinc-200 rounded-sm">
              <div>
                <div className="flex flex-row">
                  icon
                  <div className="flex flex-col">
                    <p>Electric Service</p>
                    <p>Meter #230032</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="border border-zinc-200 rounded-sm">
              <div className="flex flex-col">
                <div className="flex flex-row">
                  icon
                  <div className="flex flex-col">
                    <p>Electric Service</p>
                    <p>Meter #230032</p>
                  </div>
                </div>
                <div className="flex flex-col flex-wrap">
                  <RadioGroup name="resale" defaultValue="permit">
                    <div className="flex flex-row justify-between items-center">
                      <RadioField>
                        <Radio value="standard"/>
                        <Label>Standard Billing</Label>
                      </RadioField>

                      <p>$30.00</p>
                    </div>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="flex flex-col w-1/2">
          <h2 className="text-xl">Fee Breakdown</h2>
          <Text>
            These are the charges required to start each service. You will be required to pay these before service
            begins.
          </Text>

          <div>
            FEE TABLE HERE
          </div>
        </div>
      </div>

      <ButtonGroup>
        <Button to="/applications/$application-id/confirm" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
